import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './styles/themes.ts';
import { initAuth, checkToken, redirectToLogin } from './shared/api/auth.ts';

(async () => {

    const token = initAuth();

    if (!token) {
        redirectToLogin();
        return;
    }

    const hasAccess = await checkToken();

    if (!hasAccess) {
        redirectToLogin();
        return;
    }

    createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </StrictMode>,
    );
})();
